import {Component, OnInit, Input, SecurityContext} from '@angular/core';
import {MatDialog} from '@node_modules/@angular/material';
import { DomSanitizer, SafeResourceUrl, SafeUrl, } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-pdf',
  templateUrl: './terms-pdf.component.html',
  styleUrls: ['./terms-pdf.component.scss']
})
export class TermsPdfComponent implements OnInit {
  @Input() public terms_pdf: string;

  static modalRef;
  src: SafeResourceUrl;
  constructor(
      public dialog: MatDialog,
      private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
 // Test pdfUrl 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf'
    console.log(this.terms_pdf);
    this.src = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(this.terms_pdf));
  }

  onClose() {
      // this.dialog.closeAll();
      if (TermsPdfComponent.modalRef) {
          TermsPdfComponent.modalRef.close();
      }
  }

}
